import { LegacyCard } from '@shopify/polaris';
import { useContext, useEffect } from 'react';
import { useState } from 'react';
import ToastContext from '../../../context/ToastContext';
import { SET_ERROR, SET_OK } from '../../../context/ToastReducer';
import ProductCard from '../Products/ProductCard';
import ProductFindCard from '../Products/ProductFindCard';
import InventoryAddStockTable from '../Tables/InventoryAddStockTable';
import { getInventoryStockById, postInventoryStock } from '../../../services/inventoriesService';
import { isEAN, isUPC } from '../../../helpers/eanChecker';

const AddStockCard = ({ inventory, onStockAdded }) => {
  const [productFound, setProductFound] = useState(null);
  const [autoclean, setAutoclean] = useState(false);
  const [productListFound, setProductListFound] = useState([]);
  const [stockToAdd, setStockToAdd] = useState([]);
  const [, dispatchToast] = useContext(ToastContext);

  useEffect(() => {
    if (autoclean) {
      setProductFound(null);
      setProductListFound([]);
      setAutoclean(false);
    }
  }, [autoclean]);

  const tryAddStock = (query) => {
    if (isEAN(query) || isUPC(query)) {
      setAutoclean(true);
      handleAddQty([{ barcode: query, qty: 1, upcEph: isUPC(query) }]);
      return true;
    }
    return false;
  };

  const handleSearch = (q) => {
    //quita los espacios
    const query = q.replace(/\s/g, '');

    if (/^.{12,13}$/.test(query) && tryAddStock(query)) {
      setAutoclean(true);
      return;
    }

    if (/^.{14,}$/.test(query)) {
      const eanRegex = /84\d{11}/g;
      const upcRegex = /200\d{9}/g;

      const eanCodes = query.match(eanRegex) ?? [];
      const upcCodes = query.match(upcRegex) ?? [];
      [...eanCodes, ...upcCodes].forEach(tryAddStock);
      setAutoclean(true);
    } else
      getInventoryStockById(inventory.deposit.id, inventory.id, { s: query, empty: true }).then(({ data }) => {
        if (data.data.length === 1) {
          setProductFound(data.data[0]);
          setProductListFound([]);
        } else {
          setProductFound(null);
          setProductListFound(data.data.map(({ family }) => family));
        }
      });
  };

  const handleClearSearch = () => {
    setProductFound(null);
    setProductListFound([]);
  };

  const handleAddQty = (stockToAdd) => {
    postInventoryStock(inventory.deposit.id, inventory.id, stockToAdd)
      .then((r) => {
        onStockAdded(r.data);
        setProductFound(null);
        setProductListFound([]);
        setStockToAdd([]);
        dispatchToast({ type: SET_OK, payload: r.data });
      })
      .catch((e) => {
        dispatchToast({ type: SET_ERROR, payload: e.response.data });
      });
  };

  return (
    <LegacyCard
      title="Añadir stock"
      primaryFooterAction={
        productFound && {
          content: 'Añadir stock',
          disabled: !stockToAdd.length,
          onAction: () => handleAddQty(stockToAdd),
        }
      }
      secondaryFooterActions={
        productFound && [{ content: 'Limpiar', onAction: handleClearSearch, destructive: true, plain: true }]
      }>
      <LegacyCard.Section>
        <ProductFindCard
          onSearch={handleSearch}
          onClearSearch={handleClearSearch}
          product={productFound}
          optionList={productListFound}
          autoclean={autoclean}
        >
          {productFound && (
            <ProductCard product={productFound} wide={true}>
              <InventoryAddStockTable product={productFound} inventory={inventory} onAddQty={setStockToAdd} />
            </ProductCard>
          )}
        </ProductFindCard>
      </LegacyCard.Section>
    </LegacyCard>
  );
};

export default AddStockCard;
